<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import Modal from './Modal.svelte';
    import Button from './forms/Button.svelte';

    export let open    = false;
    export let title   = 'Alert';
    export let message = '';
    export let type: 'info' | 'warning' | 'error' | 'success' = 'info';
    export let okLabel = 'OK';

    const dispatch = createEventDispatcher<{ close: void }>();

    const icons = {
        info:    { svg: 'M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zm0 5v4m0 4h.01',        color: 'var(--color-info)' },
        success: { svg: 'M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3',         color: 'var(--color-success)' },
        warning: { svg: 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4m0 4h.01', color: 'var(--color-warning)' },
        error:   { svg: 'M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zm0 5v6m0 4h.01',        color: 'var(--color-danger)' },
    };

    $: icon = icons[type];

    function onClose() {
        open = false;
        dispatch('close');
    }
</script>

<Modal bind:open {title} size="sm" on:close={onClose}>
    <div class="alert-body">
        <svg class="alert-icon" viewBox="0 0 24 24" fill="none" stroke={icon.color}
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             width="40" height="40" aria-hidden="true">
            <path d={icon.svg}/>
        </svg>
        <p class="alert-message">{message}</p>
        <slot />
    </div>

    <svelte:fragment slot="footer">
        <Button variant={type === 'error' ? 'danger' : (type === 'success' ? 'success' : (type === 'warning' ? 'warning' : 'primary'))}
            fullWidth
            on:click={onClose}>
            {okLabel}
        </Button>
    </svelte:fragment>
</Modal>

<style lang="scss">
    .alert-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 0.75rem;
        padding: 0.5rem 0;
    }

    .alert-icon {
        flex-shrink: 0;
    }

    .alert-message {
        margin: 0;
        color: $color-text;
    }
</style>
